import React from 'react';
import PageButton from '../../elements/PageButton/PageButton';
import {getPlaceIconPath} from '../../../utils/gameEnd/getPlaceIconPath';
import {getFormattedPrice} from '../../../utils/price/getFormattedPrice';

// Медаль — первой тройке, как в Зале славы; ниже место пишется номером
const MEDAL_PLACES_COUNT = 3;

/**
 * Плашка игрока в «Лучших коллекциях». Одна и та же и в списке, и над списком
 * (там показывается сам игрок, если он не попал на текущую страницу).
 *
 * Каркас — классы плашки Зала славы (glory-hall-user-*): разделы должны
 * выглядеть одинаково. От нее здесь только место, имя и очки — без лиги, числа
 * битв и строки дохода. Бейдж «Вы» у своей плашки — отдельным элементом (в Зале
 * славы он нарисован в CSS внутри ника и на узком экране обрезается с ним).
 * Метки ИИ, в отличие от Зала славы, нет: ИИ-аккаунты сервер в этот раздел не
 * отдает (см. /api/users/best-collections).
 */
export const BestCollectionsUserItem = ({user, isCurrentUser, onClick, pageId, buttonId}) => {
  const placeIcon = user.rank <= MEDAL_PLACES_COUNT ? getPlaceIconPath(user.rank - 1) : null;

  return (
    <PageButton
      className={`glory-hall-user-item${isCurrentUser ? ' glory-hall-user-item_current-user' : ''}`}
      onClick={onClick}
      pageId={pageId}
      buttonId={buttonId}
    >
      <span className={'glory-hall-user-main-row'}>
        {placeIcon ? (
          <img
            className={'glory-hall-user-place-icon'}
            src={placeIcon}
            alt={`${user.rank} место`}
          />
        ) : (
          <span className={'glory-hall-user-place-icon glory-hall-user-place-number'}>
            {user.rank}
          </span>
        )}
        <span className={'glory-hall-user-name best-collections-user-name'}>
          {user.name}
        </span>
        {/* Бейдж — сосед ника, а не его часть: спан ника обрезает содержимое,
            и на узком экране бейдж внутри него пропадал бы первым — своя
            строка в списке осталась бы без пометки */}
        {isCurrentUser && <span className={'best-collections-user-badge'}>Вы</span>}
        {/* Старый ответ сервера без поля очков страницу ронять не должен:
            getFormattedPrice(undefined) бросает исключение */}
        <span className={'best-collections-user-points text-attention'}>
          {getFormattedPrice(user.collectionPoints ?? 0)}
        </span>
      </span>
    </PageButton>
  );
};

export default BestCollectionsUserItem;
